import Bag from '@phoenix/components/Bag';
import Product from '@phoenix/components/Product';
import createVueApp from '@phoenix/createVueApp';
import ReferenceEnquiryPanel from '../components/product/reference-enquiry-panel/ReferenceEnquiryPanel.vue';
import ReferenceEnquiryContactForm from '@maison/components/product/reference-enquiry-panel/ReferenceEnquiryContactForm.vue';

Object.assign(window, {
  Bag,
  Product,
});

const app = createVueApp({}, true);
app.component('ReferenceEnquiryPanel', ReferenceEnquiryPanel);
app.component('ReferenceEnquiryContactForm', ReferenceEnquiryContactForm);
app.mount('#phoenix-reference-enquiry-panels');
